var _ellipse, _ellipse2, _ellipse3, _ellipse4, _path, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomRightBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 463,
    viewBox: "0 0 315 463",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.149,
    cy: 416,
    rx: 77.8513,
    ry: 72,
    fill: "#4285F4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.44,
    cy: 331,
    rx: 45.8576,
    ry: 42,
    fill: "#EA4335"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 236.753,
    cy: 293.5,
    rx: 28.7943,
    ry: 26.5,
    fill: "#F9AB00"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.108,
    cy: 429,
    rx: 13.8639,
    ry: 13,
    fill: "#34A853"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2376 101.687L146.551 115.048M146.551 115.048L153.296 66.1452M146.551 115.048L208.57 144.67M153.296 66.1452L202.773 13.2741M153.296 66.1452L21.9662 43.8591M153.296 66.1452L208.57 144.67M208.57 144.67L232.943 242.299L301.157 265.111L208.57 144.67Z",
    stroke: "#D8D8D8",
    strokeWidth: 4
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.89206,
    cy: 8.76012,
    rx: 8.89206,
    ry: 8.76012,
    transform: "matrix(0.999738 -0.0228977 -0.0518401 0.998655 143.727 56.9365)",
    fill: "#EA4335"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5721,
    cy: 13.3707,
    rx: 13.5721,
    ry: 13.3707,
    transform: "matrix(0.999738 -0.0228977 -0.0518401 0.998655 34.9811 90.2397)",
    fill: "#4285F4"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.36007,
    cy: 9.22119,
    rx: 9.36007,
    ry: 9.22119,
    transform: "matrix(0.999738 -0.0228977 -0.0518401 0.998655 12.679 33.7246)",
    fill: "#F9AB00"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.65806,
    cy: 8.52959,
    rx: 8.65806,
    ry: 8.52959,
    transform: "matrix(0.999738 -0.0228977 -0.0518401 0.998655 194.668 2.88232)",
    fill: "#34A853"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.01185,
    cy: 5.06013,
    rx: 5.01185,
    ry: 5.06013,
    transform: "matrix(0.380856 0.89285 -0.930103 0.437693 211.386 136.788)",
    fill: "#EA4335"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.64968,
    cy: 7.72337,
    rx: 7.64968,
    ry: 7.72337,
    transform: "matrix(0.380857 0.892849 -0.930103 0.437693 235.73 230.943)",
    fill: "#4285F4"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.27563,
    cy: 5.32646,
    rx: 5.27563,
    ry: 5.32646,
    transform: "matrix(0.380856 0.89285 -0.930103 0.437693 148.436 107.417)",
    fill: "#F9AB00"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.87996,
    cy: 4.92698,
    rx: 4.87996,
    ry: 4.92698,
    transform: "matrix(0.380857 0.892849 -0.930103 0.437693 302.948 258.132)",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomRightBg);
export default __webpack_public_path__ + "static/media/bottom-right-bg.386f5c12f7252b861c05b90ee0cc9a1d.svg";
export { ForwardRef as ReactComponent };